// extracted by mini-css-extract-plugin
module.exports = {"text":"propertyAddress_text__AKiUu"};
    if(module.hot) {
      // 1790670310902
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  